module.exports = __webpack_public_path__ + "193ab140732c5c7710ec58b810b7e8f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/menu_icons/Assets.png
// module id = 807
// module chunks = 0